export default function getGuid(): string {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4(): string {
    return Math.floor((1 + Math.random()) * 65536)
        .toString(16)
        .substring(1);
}
